export const markerCanvasSize = 128;

// console.log(HOST);
export const config = {
    // host: 'http://localhost:1337',
    // host: 'http://emerson-cms.zeus',
    // host: 'http://emerson-globe-cms.fitch-staging.com',
    // host: HOST,
    // port: '1337'
};

export function getHost() {
    return 'https://' + HOST;
}

export const icons = [
    { type: 'who', img: 'who.svg', color: '#ffd000' },
    { type: 'what', img: 'what.svg', color: '#0ac5b4'},
    { type: 'how', img: 'how.svg', color: '#f9950c'},
    { type: 'news', img: 'news.svg', color: '#0079c2'},
    { type: 'customers', img: 'what.svg', color: '#f9950c'},
    { type: 'community', img: 'how.svg', color: '#0079c2'},
    { type: 'where', img: 'where.svg', color: '#62bb46'}
];